// Recovered compiled webpack factory 40364. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  function n(e) {
    if ("boolean" == typeof e) return Number(e);
    let t = "string" == typeof e ? parseFloat(e) : e;
    if (!("number" != typeof t || isNaN(t)) && !(t < 0) && !(t > 1)) return t;
  }
  r.d(t, { i: () => n });
}
